import { Fragments } from "requests";
import { FormValues } from "./types";

export const getInitialValues = (vaccines: Fragments.StoredVaccines) =>
  vaccines.reduce(
    (acc, current) => ({ ...acc, [current.vaccine]: current.toPerform }),
    {}
  ) as FormValues;
